export const PASSWORD_CHANGE_SESSION_EXPIRED_MESSAGE =
  "Your password change session has expired. Please request a new OTP and verify it again";
